import React from 'react';
import Styles from './GlobalStyles.css';

function GlobalStyles() {
  return (
    <>
      <style jsx global>
        {Styles}
      </style>
    </>
  );
}

export default GlobalStyles;
